/**
 * Given a list of products (a), remove any product that exists in list b
 * @param  {Array.Object} listA List of products to filter
 * @param  {Array.Object} listB List of products to check for duplicates
 * @param  {String} keyA        Key to test on listA
 * @param  {String} keyB        Key to test on listB
 * @return {Array.Object}       Filtered list
 */
const removeDuplicates = (listA, listB, keyA, keyB) =>
  listA.filter(a => listB.every(b => a[keyA] !== b[keyB]));

/**
 * Given a list of products, remove any product that matches a given slug
 * @param  {Array.Object} products List of products to filter
 * @param  {String} currentSlug    Slug to check for
 * @return {Array.Object}          Filtered list
 */
const removeMatchingSlug = (products, currentSlug) =>
  products.filter(product => product.slug !== currentSlug);

/**
 * Given a list of products, remove any product that has giveaway ticked
 * @param  {Array.Object} products List of products to filter
 * @return {Array.Object}          Filtered list
 */
const removeGiveaways = products =>
  products.filter(product => !product.giveaway);

/**
 * Run filters on recommendations to remove any matches for
 * the basket and current page
 * @param  {Array.Object} recommendations List of products to filter
 * @param  {Array.Object} basketItems     Items in the basket
 * @param  {String} currentSlug           Slug of current page to check for
 * @param  {Array.String} ownedNames  Items in the user's library (by slug)
 * @return {Array.Object}                 Filtered results
 */
const filterRecommendations = (recommendations, basketItems, currentSlug, ownedNames) => {
  let filtered = removeDuplicates(recommendations, basketItems, 'product_id', '_id');
  filtered = removeDuplicates(filtered, ownedNames.map(name => ({ name })), 'name', 'name');
  filtered = removeMatchingSlug(filtered, currentSlug);
  filtered = removeGiveaways(filtered);
  return filtered;
};

/**
 * Cut the array of recommendations down to a given length
 * @param  {Array.Object} recommendations List of products to filter
 * @param  {Number} length                [description]
 * @return {Array.Object}                 Filtered results
 */
export function limitRecommendations(products, length) {
  return products.slice(0, length);
}

/**
 * Clean existing recommendations
 * @return {Array.Object}             Product hits
 * @param  {String} currentSlug       Slug of current product
 * @param  {Array.Object} basketItems Items in the basket
 * @param  {Array.String} ownedNames  Items in the user's library (by slug)
 * @param  {Number} [count=4]         How many results to return
 * @return {Array.Object}             Product hits
 */
export function cleanRecommendations(
  hits,
  currentSlug,
  basketItems = [],
  ownedNames = [],
  count = 14,
) {
  const recommendations = filterRecommendations(hits, basketItems, currentSlug, ownedNames);
  return limitRecommendations(recommendations, count);
}
